import { words } from './globalState';
import { syncHttpRequest2 } from './utils';

// 「デュエルランキング検索」ボタン押下 HANDLE CLICK GET DUEL RANKING ALL
async function handleClickGetDuelRankingAll(state, dispatch, pagingIndex) {
  // let addressActual;
  let request = {};
  let messages = {};

  const action = state.getDuelRanking.action;
  // const now = Date.now();

  // state固定
  const stateFixed = {
    action: action,
    addressMain: state.active.addressMain,
    sessionId: state.session[state.active.addressMain]?.sessionId,
    lastEvaluatedKey: pagingIndex >= 1 ? state.getDuelRanking.lastEvaluatedKey[action.difficultyMode][action.gameMode][action.period][pagingIndex - 1] : null,
    lastRank: pagingIndex >= 1 ? state.getDuelRanking.lastRank[action.difficultyMode][action.gameMode][action.period][pagingIndex - 1] : 0,
  };

  // 入力値チェック


  request.body = JSON.stringify({
    body: {
      action: 'duelRankingAll',
      actionDetail: stateFixed.action,
      addressMain: stateFixed.addressMain,
      sessionId: stateFixed.sessionId,
      lastEvaluatedKey: stateFixed.lastEvaluatedKey,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history_open';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    // 順位付け

    const duelRankingData = response.body.duelRanking.map( (record, index) => {
      record.rank = index + 1 + stateFixed.lastRank;
      return record;
    });

    // ランキングデータを格納

    dispatch({
      type: 'setStateMultiLayers',
      keys: ['getDuelRanking', 'records', stateFixed.action.difficultyMode, stateFixed.action.gameMode, stateFixed.action.period, 'duelRanking'],
      value: duelRankingData
    });

    // lastRank格納

    dispatch({
      type: 'setStateMultiLayers',
      keys: ['getDuelRanking', 'lastRank', stateFixed.action.difficultyMode, stateFixed.action.gameMode, stateFixed.action.period, pagingIndex],
      value: stateFixed.lastRank + duelRankingData.length
    });

    // lastEvaluatedKey, pagingIndex格納

    if (response.body.lastEvaluatedKey !== undefined) {
      dispatch({
        type: 'setStateMultiLayers',
        keys: ['getDuelRanking', 'lastEvaluatedKey', stateFixed.action.difficultyMode, stateFixed.action.gameMode, stateFixed.action.period, pagingIndex],
        value: response.body.lastEvaluatedKey
      });
    }
    else {
      dispatch({
        type: 'setStateMultiLayers',
        keys: ['getDuelRanking', 'lastEvaluatedKey', stateFixed.action.difficultyMode, stateFixed.action.gameMode, stateFixed.action.period, pagingIndex],
        value: null
      });
    }

    dispatch({
      type: 'setStateMultiLayers',
      keys: ['getDuelRanking', 'pagingIndex', stateFixed.action.difficultyMode, stateFixed.action.gameMode, stateFixed.action.period],
      value: pagingIndex
    });

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'searchPurchaseHistory',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: now,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

export {
  handleClickGetDuelRankingAll,
};